export interface PurchaseLineInput {
  item_id?: string;
  variant_id?: string | null;
  item_kind: 'catalog' | 'manual';
  description?: string | null;
  inventory_treatment: 'tracked' | 'non_stock' | 'link_required' | 'reference_only';
  quantity: number;
  unit_cost: number;
  discount: number;
}
export interface PurchaseRecordMetadata {
  workflow_mode: 'legacy_stock' | 'record_only';
  details_mode: 'amount_only' | 'itemized' | null;
  entered_amount: number | null;
  payment_tracking_mode: 'tracked' | 'untracked' | null;
  delivered_on: string | null;
  is_deleted: boolean;
  archived_at: string | null;
  deletion_reason: string | null;
  payment_state?: string;
  supplier_balance?: number | null;
}
export function purchasePaymentState(
  p: { payment_status: string } & Partial<PurchaseRecordMetadata>,
) {
  return p.workflow_mode === 'record_only' && p.payment_tracking_mode === 'untracked'
    ? 'not_recorded'
    : p.payment_status;
}
export function purchaseBalance(p: { balance_due: number } & Partial<PurchaseRecordMetadata>) {
  return p.workflow_mode === 'record_only' && p.payment_tracking_mode === 'untracked'
    ? null
    : Number(p.balance_due);
}
export function purchaseStatusLabel(p: { status: string } & Partial<PurchaseRecordMetadata>) {
  if (p.workflow_mode === 'record_only')
    return (
      ({ ordered: 'Pending', received: 'Delivered', draft: 'Draft' } as Record<string, string>)[
        p.status
      ] || p.status
    );
  return p.status.replaceAll('_', ' ');
}
export function purchaseVariantDetails(item: {
  variant_snapshot?: { sku?: string | null; size?: string | null; color?: string | null } | null;
  product_variants?: { sku: string; size: string; color: string | null } | null;
}) {
  return item.variant_snapshot ?? item.product_variants ?? {};
}
export function purchaseTotals(
  items: Array<Pick<PurchaseLineInput, 'quantity' | 'unit_cost' | 'discount'>>,
  charges = 0,
) {
  const subtotal = items.reduce(
    (sum, item) => sum + item.quantity * Math.round(item.unit_cost * 100),
    0,
  );
  const discount = items.reduce((sum, item) => sum + Math.round(item.discount * 100), 0);
  return {
    subtotal: subtotal / 100,
    discount: discount / 100,
    total: (subtotal - discount + Math.round(charges * 100)) / 100,
  };
}

export function purchaseLifecycleLabel(p: Partial<PurchaseRecordMetadata>) {
  return p.is_deleted ? 'In recycle bin' : p.archived_at ? 'Archived' : null;
}
